import { api } from '@/redux/apiSlice'
import TAGS from '@/redux/cacheTags'
import { objectToQueryParams } from '@/utils/url-utils'

const extendedApi = api.injectEndpoints({
    endpoints: (build) => ({
        getAllEmailProviders: build.query({
            query: () => `marketingemail/`,
            providesTags: [TAGS.emailProviders],
        }),
        getEmailProvider: build.query({
            query: ({ email_provider_id }) => `marketingemail/${email_provider_id}/`,
            providesTags: [TAGS.emailProvider],
        }),
        createEmailProvider: build.mutation({
            query: (data) => ({
                url: `marketingemail/`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: [TAGS.emailProviders],
        }),
        updateEmailProvider: build.mutation({
            query: ({ id, ...data }) => ({
                url: `marketingemail/${id}/`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: [TAGS.emailProviders],
        }),
        testEmailProvidersCredentials: build.mutation({
            query: (data) => ({
                url: `marketingemail/test/`,
                method: 'POST',
                body: data,
            }),
        }),
        deleteEmailProvider: build.mutation({
            query: ({ provider_id }) => ({
                url: `marketingemail/${provider_id}/`,
                method: 'DELETE',
            }),
            invalidatesTags: [TAGS.emailProviders],
        }),
        deleteEmailProviderConfig: build.mutation({
            query: ({ provider_id, configuration_id }) => ({
                url: `marketingemail/${provider_id}/configurations/${configuration_id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [TAGS.emailProviders],
        }),
        getAccountListInfo: build.query({
            query: ({ provider_type, ...params }) => ({
                url: `${provider_type}/lists/`,
                params: objectToQueryParams({ ...params }),
            }),
            providesTags: [TAGS.emailProviderList],
        }),
    }),
})

export const {
    useGetAllEmailProvidersQuery,
    useGetEmailProviderQuery,
    useCreateEmailProviderMutation,
    useUpdateEmailProviderMutation,
    useTestEmailProvidersCredentialsMutation,
    useDeleteEmailProviderMutation,
    useDeleteEmailProviderConfigMutation,
    useGetAccountListInfoQuery,
    useLazyGetAccountListInfoQuery,
} = extendedApi
